import { extend } from 'vee-validate';
import { validator } from './runtime';

extend('crm', {
    ...validator,
    message: 'The code you entered is not valid or incomplete for this provider'
});
